import React from 'react'

const CarouselControls = ({ isAutoPlaying, onScrollLeft, onScrollRight, onToggleAutoPlay }) => {
  return (
    <div className="absolute top-4 right-4 flex gap-2 z-10">
      <NavigationButton
        onClick={onScrollLeft}
        title="Previous"
        icon={<LeftArrowIcon />}
      />
      <NavigationButton
        onClick={onScrollRight}
        title="Next"
        icon={<RightArrowIcon />}
      />
      <NavigationButton
        onClick={onToggleAutoPlay}
        title={isAutoPlaying ? "Pause" : "Play"}
        icon={isAutoPlaying ? <PauseIcon /> : <PlayIcon />}
      />
    </div>
  )
}

const NavigationButton = ({ onClick, title, icon }) => (
  <button
    onClick={onClick}
    className="bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors"
    title={title}
  >
    {icon}
  </button>
)

const LeftArrowIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
)

const RightArrowIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
)

const PauseIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6" />
  </svg>
)

const PlayIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M8 5v14l11-7z" />
  </svg>
)

export default CarouselControls